import { MultiSelect } from 'primereact/multiselect';
import { Tooltip } from 'primereact/tooltip';
import { Generico } from '../../Generico';

export const FiltroCatalogoFijo = ({ value, onChange, options, placeholder = "Seleccionar...", optionLabel = "label", optionValue = "value", tooltipPosition = "right", icon = "pi pi-list", ...props }) => {
    const { toHtmlId } = Generico();

    const itemTemplate = (option) => {
        const label = option?.[optionLabel] ?? option;
        const tooltipId = toHtmlId('tooltip-single-ac', option?.value ?? label);
        const hasColor = option?.color;

        const handleMouseEnter = (e) => {
            const el = e.currentTarget;
            if (el.scrollWidth <= el.offsetWidth) {
                el.removeAttribute('data-pr-tooltip');
            } else {
                el.setAttribute('data-pr-tooltip', label);
            }
        };

        return (
            <div style={{ width: '100%', overflow: 'hidden' }}>
                <span id={tooltipId} data-pr-tooltip={label} data-pr-position={tooltipPosition} onMouseEnter={handleMouseEnter}
                    style={{
                        display: 'inline-block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',
                        maxWidth: '250px', cursor: 'default',
                        ...(hasColor && {
                            backgroundColor: `#${option.color}`, color: `#${option.color_texto ?? '000000'}`,
                            padding: '2px 10px', borderRadius: '4px',
                        })
                    }}
                >
                    {label}
                </span>
                <Tooltip
                    target={`#${tooltipId}`}
                    pt={{
                        text: { style: { maxWidth: '300px', whiteSpace: 'normal', wordBreak: 'break-word', textAlign: 'justify' } }
                    }}
                />
            </div>
        );
    };

    return (
        <div className="p-inputgroup w-full">
            <span className="p-inputgroup-addon bg-white px-3">
                <i className={`${icon} text-primary`}></i>
            </span>
            <MultiSelect display="chip" filter maxSelectedLabels={1} {...props} value={value || []} options={options}
                onChange={(e) => onChange(e.value)} optionLabel={optionLabel} optionValue={optionValue} placeholder={placeholder} className="w-full"
                itemTemplate={itemTemplate} selectedItemsLabel="{0} elementos seleccionados" pt={{ tokenLabel: { style: { maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } } }} />
        </div>
    );
};